(() => {
  document.addEventListener(
    'click',
    (event) => {
      const popup = document.querySelector('[data-testid="POPUP"]');
      const form = popup?.querySelector('.klaviyo-form');

      if (
        !form ||
        !popup.getClientRects().length ||
        form.contains(event.target) ||
        event.target.closest?.('.klaviyo-close-form')
      )
        return;

      popup.querySelector('.klaviyo-close-form')?.click();
    },
    true
  );
})();
